import React from 'react'
import styles from "./Banner.module.scss"

export default function Banner() {
  return (
    <div className={styles.bannerParent}>
      <h1>
        Altra Edge
      </h1>
      <div className={styles.subheading}>
        Fuelling Growth Through Data-Driven Lead Generation & Performance Marketing
      </div>
    </div>
  )
}
